export default __webpack_public_path__ + "static/media/nuclide.f8679cce.svg";